import {useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  CheckWrapper,
  InputTextWrapper,
  InputHourWrapper,
  InputDateWrapper,
  SelectWrapper,
} from '../../../../../../components/UI/Form/Input'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useSites} from '../../../../hooks/central/useSites'
import {CLEANING_SCHEDULE_SERVICES} from '../../../../services'
import {TabLimpiezaModel} from '../../../../../../models'

export const CleaningScheduleForm = () => {
  const allValue = '4EsB2NAAsDA='

  const {
    setError,
    setValue,
    watch,
    formState: {errors},
    register,
  } = useFormContext()

  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const {getCompanies, companies, clearCompanies} = useCompanies()
  const {getClients, clients, clearClients} = useClients()
  const {getSites, sites, clearSites} = useSites()
  const {getCampaments, campaments, clearCampaments} = useCampaments()
  const {getTypeBuildings, typeBuildings} = useParameters()

  const validationPeriodic =
    errors?.FechaFin ||
    errors?.FechaInicio ||
    errors?.HoraInicio ||
    errors?.CantidadRepeticion ||
    errors?.TipoRepeticion ||
    errors?.days
      ? true
      : false

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getTypeBuildings({pageNumber: 1, size: 200, tableName: 'TipoEdificacion'})
    return () => {
      clearCompanies()
      clearClients()
      clearSites()
      clearCampaments()
    }
  }, [])

  useEffect(() => {
    if (companies.length === 1) {
      setValue('CompaniaId', companies[0].value)
      setError('CompaniaId', {})
      getClients({isCombo: true, companiaId: companies[0].value}, 1)
    }
  }, [companies])

  useEffect(() => {
    if (clients.length === 1) {
      setValue('ClienteId', clients[0].value)
      setError('ClienteId', {})
      getSites({isCombo: true, clienteId: clients[0].value}, 1)
    }
  }, [clients])

  useEffect(() => {
    if (sites.length === 1) {
      setValue('SiteId', sites[0].value)
      setError('SiteId', {})
      getCampaments({isCombo: true, siteId: sites[0].value}, 1, {
        all: true,
        value: allValue,
        label: 'TODOS',
      })
    }
  }, [sites])

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
    }
  }, [campaments])

  useEffect(() => {
    if (typeBuildings.length > 0) {
      setValue('TipoEdificacionId', typeBuildings[typeBuildings.length - 1].value)
      setError('TipoEdificacionId', {})
    }
  }, [typeBuildings])

  const getCellphoneById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await CLEANING_SCHEDULE_SERVICES.getByIdCleaningSchedule(idToEdit)
        if (data) {
          const {
            // Id,
            CampamentoId,
            TipoEdificacionId,
            Nomenclatura,
            // Nombre,
            FechaInicio,
            HoraInicio,
            FechaFin,
            CantidadRepeticion,
            TipoRepeticion,
            DiasSeleccionado,
            EsPeriodico,
            CompaniaId,
            ClienteId,
            SiteId,
            Actividades,
          } = data

          const dias = ['LU', 'MA', 'MI', 'JU', 'VI', 'SA', 'DO']

          const selectedDays = (DiasSeleccionado || '').split('-')

          const days = dias.map((dia) => selectedDays.includes(dia))

          setValue('Id', idToEdit)
          setValue('CampamentoId', CampamentoId)
          setValue('CompaniaId', CompaniaId)
          setValue('ClienteId', ClienteId)
          setValue('SiteId', SiteId)
          setValue('TipoEdificacionId', TipoEdificacionId)
          setValue('Nomenclatura', Nomenclatura)
          setValue('EsPeriodico', EsPeriodico)
          setValue('FechaInicio', FechaInicio.split('T')[0])
          setValue('HoraInicio', HoraInicio)
          setValue('CantidadRepeticion', CantidadRepeticion)
          setValue('TipoRepeticion', TipoRepeticion)
          setValue('FechaFin', FechaFin.split('T')[0])
          setValue('days', days)
          getClients({isCombo: true, companiaId: CompaniaId}, 1)
          getSites({isCombo: true, clienteId: ClienteId}, 1)
          getCampaments({isCombo: true, siteId: SiteId}, 1, {
            all: true,
            value: allValue,
            label: 'TODOS',
          })
        }
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getCellphoneById()
    }
  }, [currentTabItem.idToEdit])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    clearSites()
    setValue('CampamentoId', '')
    clearCampaments()
    setError('CompaniaId', {})
    clearClients()
    getClients({isCombo: true, companiaId: value}, 1)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    clearSites()
    clearCampaments()
    setError('ClienteId', {})
    getSites({isCombo: true, clienteId: value}, 1)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    clearCampaments()
    getCampaments({isCombo: true, siteId: value}, 1, {
      all: true,
      value: allValue,
      label: 'TODOS',
    })
  }

  const repeatEvery = Array.from({length: 99}, (_, i) => ({
    value: i + 1,
    label: (i + 1).toString(),
  }))

  const days = [
    {label: 'LU', index: 0},
    {label: 'MA', index: 1},
    {label: 'MI', index: 2},
    {label: 'JU', index: 3},
    {label: 'VI', index: 4},
    {label: 'SA', index: 5},
    {label: 'DO', index: 6},
  ]

  const values = watch('days') || []

  return (
    <>
      {/*<ContentForm isEdit={isDisabled} title='Datos de la Programación'>*/}
      <div className='sdx_form card p-4'>
        <div className='d-flex row'>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Compañia'
              name='CompaniaId'
              data={companies}
              onChangeValue={handleCompanyChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Cliente'
              name='ClienteId'
              data={clients}
              onChangeValue={handleClientChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Site'
              name='SiteId'
              data={sites}
              onChangeValue={handleSiteChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Campamento' name='CampamentoId' data={campaments} required />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Tipo de Edificación'
              name='TipoEdificacionId'
              data={typeBuildings}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Programacion de Servicio'
              name='Nomenclatura'
              textPlaceholder='Escribe el servicio'
              required
            />
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3 d-flex align-items-start flex-column justify-content-center'>
            <div className=''>
              <CheckWrapper name='EsPeriodico' nameCheck='Hacer Periódico' className='h-100' />
            </div>
            {false && validationPeriodic && (
              <p className='error-message'>Completar campos de repetición</p>
            )}
          </div>
        </div>
        {watch('EsPeriodico') && (
          <>
            <hr />
            <div className='d-flex row'>
              <div className='mb-2 col-sm-12 col-md-6'>
                <InputDateWrapper
                  labelText='Fecha de inicio'
                  name='FechaInicio'
                  minValue='1900-01-01'
                />
              </div>
              <div className='mb-2 col-sm-12 col-md-6'>
                <InputHourWrapper labelText='Hora de inicio' name='HoraInicio' />
              </div>
              <div className='mb-2 col-sm-12 col-md-6'>
                <SelectWrapper
                  labelText='Repetir cada'
                  name='CantidadRepeticion'
                  data={repeatEvery}
                />
              </div>
              <div className='mb-2 col-sm-12 col-md-6'>
                <SelectWrapper
                  labelText='Periodo'
                  name='TipoRepeticion'
                  data={[
                    {value: 'DIARIO', label: 'DIARIO'},
                    {value: 'SEMANAL', label: 'SEMANAL'},
                    {value: 'MENSUAL', label: 'MENSUAL'},
                    {value: 'ANUAL', label: 'ANUAL'},
                  ]}
                />
              </div>
              <div className='d-flex flex-wrap gap-10 justify-content-center mb-6 mt-4'>
                {days.map((day) => {
                  const isActive = values[day.index]
                  return (
                    <div key={day.index}>
                      <input
                        type='checkbox'
                        className='btn-check'
                        id={`day_${day.index}`}
                        {...register(`days.${day.index}`)}
                      />
                      <label
                        htmlFor={`day_${day.index}`}
                        className={`
                          btn btn-outline btn-outline-dashed p-7
                          d-flex align-items-center justify-content-center
                          ${isActive ? 'active' : ''}
                        `}
                      >
                        <span className='fw-bolder fs-4'>{day.label}</span>
                      </label>
                    </div>
                  )
                })}
              </div>
              <div className='mb-2 col-sm-12 col-md-6'>
                <InputDateWrapper labelText='Fecha de Fin' name='FechaFin' minValue='1900-01-01' />
              </div>
            </div>
          </>
        )}
      </div>
      {/* <ModalPeriodicCleaning show={showPeriodicModal} setShow={setShowPeriodicModal} /> */}
    </>
  )
}
